if not App.angularApp?
    return

App.angularApp.directive 'mfRangeDatepicker', ['$parse', ($parse) ->
    return {
        scope:
            options: '='
            year: '='
            minYear: '='
            maxYear: '='
            limitYearFilter: '='
        require: 'ngModel'
        link: (scope, ele, attrs, ngModel) ->
            # set default options
            scope.options ?= {}
            scope.options.autoApply ?= true
            scope.options.linkedCalendars ?= true
            scope.options.autoUpdateInput ?= true
            scope.options.parentEl ?= '#bs2-container'

            # apparently the value can be either an object or a string?? ew..
            parseVal = (val) ->
                if not val
                    return []
                if typeof val is 'object'
                    return [val.startDate, val.endDate]
                else
                    return val.split(' - ')

            # set start/end date on the widget options so it doesn't overwrite
            # it when it's initialized (not sure why it needs .$parent.$parent)
            # we can't just use ngModel.$modelValue because it isn't set yet :(
            initial_value = $parse(attrs.ngModel)(scope.$parent.$parent)
            if initial_value and scope.options.autoApply
                [start_date, end_date] = parseVal(initial_value)
                scope.options.startDate = start_date if start_date?
                scope.options.endDate = end_date if end_date?

            # initialize date range picker
            ele.daterangepicker(scope.options)

            # update the widget if the model changes
            scope.$parent.$parent.$watch attrs.ngModel, (val) ->
                [start_date, end_date] = parseVal(val)

                datepicker = ele.data('daterangepicker')
                datepicker.setStartDate(start_date) if start_date?
                datepicker.setEndDate(end_date) if end_date?
            , true

            # Watch for dates to change and modify ngModel
            ele.on 'apply.daterangepicker', (ev, picker) =>
                ngModel.$setViewValue
                    startDate: picker.startDate
                    endDate: picker.endDate
                unless scope.options.autoUpdateInput
                    ele.val "#{picker.startDate.format('MM/DD')} - #{picker.endDate.format('MM/DD')}"

            if initial_value and scope.options.autoApply
                # run the input value formatting so it isn't [object Object]
                ele.trigger 'apply.daterangepicker', ele.data('daterangepicker')

            setMinMaxYear = (years) =>
                datepicker = ele.data('daterangepicker')

                # years should be an array, but may be null in some cases
                if years?.length > 0
                    # find min/max
                    min_year = _.min years
                    max_year = _.max years

                    # limit min/max dates to years
                    datepicker.minDate = moment("#{min_year}-1-1", 'YYYY-MM-DD')
                    datepicker.maxDate = moment("#{max_year}-12-31", 'YYYY-MM-DD')

                    # prevent bad values
                    startDate = datepicker.startDate
                    endDate = datepicker.endDate
                    if startDate.isAfter(datepicker.maxDate)
                        datepicker.setStartDate(startDate.year(max_year))
                    if endDate.isAfter(datepicker.maxDate)
                        datepicker.setEndDate(endDate.year(max_year))
                    if endDate.isBefore(datepicker.minDate)
                        datepicker.setEndDate(endDate.year(min_year))
                    if startDate.isBefore(datepicker.minDate)
                        datepicker.setStartDate(startDate.year(min_year))
                else
                    # remove min/max limit
                    datepicker.minDate = false
                    datepicker.maxDate = false

            # if the year changes, update the min/max dates
            if scope.year?
                scope.$watch 'year', (newYear, oldYear) ->
                    setMinMaxYear([newYear])

            if scope.minYear?
                scope.$watch 'minYear', (newYear, oldYear) ->
                    setMinMaxYear([newYear, scope.maxYear])

            if scope.maxYear?
                scope.$watch 'maxYear', (newYear, oldYear) ->
                    setMinMaxYear([scope.minYear, newYear])

            # If the years filter changes, update the min/max dates
            if scope.limitYearFilter?
                scope.$watchCollection () =>
                    year.key for year in scope.limitYearFilter.selected_values ? []
                , setMinMaxYear
    }
]
